<template>
    <b-table
            :data="data"
            :paginated="true"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :striped="true"
            :loading="loading"
            default-sort="purchaseDate"
            :narrowed="true"
            default-sort-direction="desc">

            <template slot-scope="props">

                <b-table-column field="produktnavn" label="Produktnavn" sortable>
                    {{ props.row.productName }}
                </b-table-column>

                <b-table-column field="purchaseDate" label="Oppgjørsdato" sortable>
                    {{ props.row.purchaseDate | moment("D. MMM YYYY") }}
                </b-table-column>              

                <b-table-column field="AnulledGiftcardAmount" label="Nullstilt gavekort beløp" numeric sortable>
                    {{ props.row.anulledGiftcardAmount | currency }}
                </b-table-column>

                <b-table-column field="LoadedGiftcardAmount" label="Ladet gavekort beløp" numeric sortable>
                    {{ props.row.loadedGiftcardAmount | currency }}
                </b-table-column>

                <b-table-column field="TransferredGiftcardAmount" label="Overført beløp gavekort" numeric sortable>
                    {{ props.row.transferredGiftcardAmount | currency }}
                </b-table-column>
                
                <b-table-column :visible="viewSource" field="kilde" label="Kilde" sortable>
                    {{ props.row.sourceFile }}
                </b-table-column>
                
            </template>

            <template slot="footer">
                <th>
                    <div class="th-wrap">Sum totalt</div>
                </th>

                <th>
                    <div class="th-wrap"></div>
                </th>


                <th>
                    <div class="th-wrap is-numeric">{{ totals.sumAnnulledGiftcards | currency }}</div>
                </th>

                <th>
                    <div class="th-wrap is-numeric">{{ totals.sumLoadedGiftcards | currency }}</div>
                </th>

                <th>
                    <div class="th-wrap is-numeric">{{ totals.sumTransferredGiftcards | currency }}</div>
                </th>


                <th v-if="viewSource">
                    <div class="th-wrap"></div>
                </th>
            </template>

        </b-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['viewSource'],
    data () {
        return {
            perPage: 40,
            currentPage: 1,
        }
    },
    computed: {
        ...mapGetters('manualtransactions', ['data', 'loading', 'totals'])
    }

}
</script>

<style lang="scss" scoped>
    .b-table {
        // font-size: 90%;
        font-size: 14px;
    }
</style>
